module.exports = __webpack_public_path__ + "img/report-3.9662de8a.jpg";